import React, { useContext, useState } from 'react'
import { BlueConicConfigurationContext } from '../configuration/context'
import { BlueConicMetaFiltersEditor } from './meta-filters/blueconic-meta-filters-editor'
import { BlueConicProductFiltersBuilder } from './blueconic-product-filters'
import { Tabs } from 'antd'
import { MAX_META_FILTERS_VALUE, MAX_PRODUCT_FILTERS_VALUE } from '../constants'

export const BlueConicFiltersEditor = () => {
    const context = useContext(BlueConicConfigurationContext)
    const [activeTab, setActiveTab] = useState('included-filters')

    const includedFiltersLength = context.filters.included.size
    const excludedFiltersLength = context.filters.excluded.size

    const tabList = [
        {
            key: 'included-filters',
            tab: (
                <>
                    Included Filters{' '}
                    <span className="size-label">
                        ({includedFiltersLength}/{MAX_META_FILTERS_VALUE})
                    </span>
                </>
            ),
            content: ({ key }) => (
                <div key={key} className="configuration-included-filters-section">
                    <BlueConicMetaFiltersEditor
                        configId={context.id}
                        filters={context.filters.included}
                        filterType="included"
                    />
                </div>
            ),
        },
        {
            key: 'excluded-filters',
            tab: (
                <>
                    Excluded Filters{' '}
                    <span className="size-label">
                        ({excludedFiltersLength}/{MAX_META_FILTERS_VALUE})
                    </span>
                </>
            ),
            content: ({ key }) => (
                <div key={key} className="configuration-excluded-filters-section">
                    <BlueConicMetaFiltersEditor
                        configId={context.id}
                        filters={context.filters.excluded}
                        filterType="excluded"
                    />
                </div>
            ),
        },
        {
            key: 'products-filters',
            tab: (
                <>
                    Product Filters{' '}
                    <span className="size-label">
                        ({context.filters.products.length}/{MAX_PRODUCT_FILTERS_VALUE})
                    </span>
                </>
            ),
            content: ({ key }) => (
                <div key={key} className="configuration-product-filters-section">
                    <BlueConicProductFiltersBuilder filters={context.filters.products} />
                </div>
            ),
        },
    ]

    return (
        <div className="card-container">
            <Tabs
                className="filters-tabbed-card"
                tabBarGutter={0}
                type="card"
                size="small"
                defaultActiveKey="included-filters"
                activeKey={activeTab}
                onChange={setActiveTab}
            >
                {tabList.map((tab, idx) => {
                    const size = tab.key === 'included-filters' ? includedFiltersLength : excludedFiltersLength
                    const sizeType = size > 9 ? 'with-long-total' : size > 1 ? 'with-short-total' : 'no-total'
                    return (
                        <Tabs.TabPane tab={tab.tab} key={`${tab.key}`} className={`${tab.key}-tab-pane ${sizeType}`}>
                            {tab.content({
                                key: tab.key + 'tabs' + `_${idx}_${sizeType}`,
                            })}
                        </Tabs.TabPane>
                    )
                })}
            </Tabs>
        </div>
    )
}
